import React from 'react';
import { useDispatch } from 'react-redux';
import { setAppRoute } from '../../data/redux/slices/appSlice';

/**
 * NavLink component that provides both Redux navigation and standard browser link behavior
 *
 * - Normal clicks: Uses Redux navigation (maintains current app flow)
 * - Cmd/Ctrl+clicks: Opens in new tab (browser handles it)
 * - Right-clicks: Shows browser context menu with "Open in new tab"
 * - Middle clicks: Opens in new tab (browser handles it)
 */
export function NavLink({ to, children, className, style, onClick, ...rest }) {
    const dispatch = useDispatch();

    const handleClick = (e) => {
        // Let browser handle if user wants new tab/window
        // metaKey = Cmd on Mac, ctrlKey = Ctrl on Windows/Linux
        // button === 1 = middle mouse button
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) {
            return;
        }

        // Otherwise prevent default page reload and use Redux navigation
        e.preventDefault();
        dispatch(setAppRoute({ route: to }));

        // Call any additional onClick handler
        onClick?.();
    };

    const handleAuxClick = (e) => {
        // Handle middle mouse button click
        if (e.button === 1) {
            // Let browser handle it (will open in new tab)
            return;
        }
    };

    return (
        <a
            href={to}
            onClick={handleClick}
            onAuxClick={handleAuxClick}
            className={className}
            style={style}
            {...rest}
        >
            {children}
        </a>
    );
}
